import { render, staticRenderFns } from "./PurchaseModalLink.vue?vue&type=template&id=49a318b7&"
import script from "./PurchaseModalLink.vue?vue&type=script&lang=js&"
export * from "./PurchaseModalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports